import { render, staticRenderFns } from "./keyword.vue?vue&type=template&id=c71ff98a&scoped=true"
import script from "./keyword.vue?vue&type=script&lang=js"
export * from "./keyword.vue?vue&type=script&lang=js"
import style0 from "./keyword.vue?vue&type=style&index=0&id=c71ff98a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71ff98a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/测试环境-前端-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c71ff98a')) {
      api.createRecord('c71ff98a', component.options)
    } else {
      api.reload('c71ff98a', component.options)
    }
    module.hot.accept("./keyword.vue?vue&type=template&id=c71ff98a&scoped=true", function () {
      api.rerender('c71ff98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/keyword.vue"
export default component.exports